var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsageTracking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,73.9c0,2.8,2.2,5,5,5h53c1.1,0,2-0.9,2-2v-2.1c0-1.1-0.9-2-2-2H26.9c-1,0-1.9-0.9-1.9-1.9V20.9 c0-1.1-0.9-2-2-2H21c-1.1,0-2,0.9-2,2V73.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4,57.9c-0.8,0-1.5-0.3-2.1-0.9c-1.2-1.2-1.2-3.1,0-4.2l16-15.9c1.2-1.2,3.1-1.2,4.2,0l7.7,7.7l13.5-13.7 c1.2-1.2,3.1-1.2,4.2,0c1.2,1.2,1.2,3.1,0,4.2L62.4,50.8c-0.6,0.6-1.3,0.9-2.1,0.9h0c-0.8,0-1.6-0.3-2.1-0.9l-7.8-7.7L36.6,57 C36,57.6,35.2,57.9,34.4,57.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsageTracking);
export default __webpack_public_path__ + "static/media/usage-tracking.f1bd0a54.svg";
export { ForwardRef as ReactComponent };